import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=69c0ebe4&"
import script from "@/views/Users/Teacher/Profile.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Teacher/Profile.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Teacher/profile.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports